
import * as React from "react";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {SearchItem} from "./SearchItem";
import {TextCondition} from "./Conditions/TextCondition";
import {MultipleItemsCondition} from "./Conditions/MultipleItemsCondition";
import {DateCondition} from "./Conditions/DateCondition";
import {NumberCondition} from "./Conditions/NumberCondition";
import {ToastService} from "shared/utilities/services/ToastService";

export class AdvancedSearchControls extends React.Component<AdvancedSearchControlsProps, AdvancedSearchControlsState> {
    static defaultProps: Partial<AdvancedSearchControlsProps> = {};
    public Fields:any[];



    constructor(props: AdvancedSearchControlsProps) {
        super(props);
        this.Fields=[];
        this.state = {};
        this.RegenerateAvailableFields(this.props.FormElements);


    }


    componentWillReceiveProps(nextProps: Readonly<AdvancedSearchControlsProps>, nextContext: any): void {
        if(nextProps.Form!=this.props.Form) {
            this.RegenerateAvailableFields(nextProps.FormElements);
            this.forceUpdate();
        }
    }

    public render() {
        return (
            <div className={'rnAdvancedSearch'}>
                <table style={{width:'100%',maxWidth:800}}>
                    <thead>
                        <tr>
                            <th style={{textAlign:'left'}}>Field</th>
                            <th style={{textAlign:'left'}}>Operation</th>
                            <th style={{textAlign:'left'}}>Value</th>

                        </tr>
                    </thead>
                    <tbody>
                        {this.props.Conditions.map(x=>

                            <SearchItem Remove={()=>this.RemoveCondition(x)} key={x.Id} Condition={x} Fields={this.Fields} FieldChanged={()=>this.forceUpdate()} Add={()=>this.AddCondition()}/>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    private RegenerateAvailableFields(formElements: any) {
        this.Fields=[];
        this.props.Conditions.length=0;
        this.props.Conditions.push(new Condition());
        if(formElements==null)
        {
            this.forceUpdate();
            return;
        }



        for(let options of formElements.ElementOptions)
        {

            switch (options.ClassName) {
                case 'rednaotextinput':
                case 'rednaorating':
                case 'rednaoprependedtext':
                case 'rednaoappendedtext':
                case 'rednaoemail':
                case 'rednaoprependedcheckbox':
                case 'rednaoappendedcheckbox':
                case 'rednaotextarea':
                case 'rednaoname':
                case 'rednaoaddress':
                case 'rednaophone':
                    this.Fields.push(new TextCondition(options));
                    break;
                case 'rednaocurrency':
                case 'rednaonumber':
                    this.Fields.push(new NumberCondition(options));
                    break;
                case 'rednaomultiplecheckboxes':
                case 'rednaosearchablelist':
                case 'rednaoselectbasic':
                case 'rednaomultipleradios':
                    this.Fields.push(new MultipleItemsCondition(options));
                    break;
                case 'rednaodatepicker':
                    this.Fields.push(new DateCondition(options));
            }
        }



    }

    private RemoveCondition(x: any) {
        if(this.props.Conditions.length==1)
        {
            ToastService.SendErrorMessage('There should be at least one condition');
            return;
        }

        this.props.Conditions.splice(this.props.Conditions.indexOf(x),1);
        this.forceUpdate();
    }

    private AddCondition() {
        this.props.Conditions.push(new Condition());
        this.forceUpdate();
    }
}


export class Condition{
    FieldId:string;
    Comparison:string;
    Value:string;
    Join:string;
    OpenParenthesis:boolean;
    CloseParenthesis:boolean;
    public Id:number;


    public static _LastId:number=0;
    public constructor(){
        Condition._LastId++;
        this.Id=Condition._LastId++;

        this.FieldId='';
        this.Comparison='';
        this.Value='';
        this.Join='';
        this.OpenParenthesis=false;
        this.CloseParenthesis=false;
    }
}

//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AdvancedSearchControlsProps {
    Form:string;
    FormElements:any;
    Conditions:Condition[];
}

interface AdvancedSearchControlsState {

}

//#endregion "My Region"